"use client";

import Link from "@casino/client/components/Link";
import Img from "@casino/legacyUi/Img";
import { cn } from "@workspace/frontend-ui";

export type ThemeGame = {
  id: string;
  handle?: string;
  name?: string;
  thumbUrl?: string;
  href?: string;
};

type Props = {
  title: string;
  color: string;
  games: ThemeGame[];
  isMobile: boolean;
};

const gridAreas = [
  "[grid-area:one]",
  "[grid-area:two]",
  "[grid-area:three]",
  "[grid-area:four] mt-1",
  "[grid-area:five] mt-1",
  "[grid-area:six] mt-3",
  "[grid-area:seven] mt-2",
];

const ThemeContent: FC<Props> = ({ title, color, games, isMobile }) => (
  <div
    className={cn(
      'grid grid-cols-[9.5rem_4.5rem_4.5rem_7.5rem] grid-rows-[5.5rem_3.5rem_1.5rem_1.5rem_3.5rem] gap-2 [grid-template-areas:"title_title_title_three"_"._six_six_two"_"seven_six_six_two"_"seven_six_six_one"_"seven_five_four_one"]',
      isMobile &&
        'grid-cols-[4.5rem_4.5rem_7.5rem] grid-rows-[3.5rem_1.5rem_1.5rem_3.5rem] [grid-template-areas:"title_title_two"_"._four_two"_"._four_one"_"five_three_one"]',
    )}
    data-testid="images-grid"
  >
    <p
      className={cn(
        "left-6 pt-5 font-headline text-[2rem] font-light [grid-area:title]",
        isMobile && "pt-0 text-2xl",
      )}
      style={{ color }}
      data-testid="theme-title"
    >
      {title}
    </p>
    {games.map((game, index) => (
      <div className={cn(gridAreas[index])} key={game.id}>
        <Link href={game.href ?? ""} className="relative z-2 block">
          <Img
            className="rounded-lg"
            src={game.thumbUrl ?? ""}
            alt={game.name ?? ""}
            width={152}
            height={152}
          />
        </Link>
      </div>
    ))}
  </div>
);

export default ThemeContent;
